import { useTranslation } from 'react-i18next'

import { Skeleton, SkeletonTheme } from 'shared/ui/skeleton'

import { TicketSkeletonCard } from './components/ticket-skeleton-card'
import s from './styles.module.scss'

export const MyOrderListSkeleton = () => {
  const { t } = useTranslation()

  return (
    <SkeletonTheme
      baseColor="var(--grey-white-5)"
      highlightColor="var(--light-grey-4)"
      duration={1.8}
    >
      <div
        className={s.list}
        role="status"
        aria-label={t('loading')}
      >
        <div
          className={s.groups}
          aria-hidden="true"
        >
          {[0, 1].map((group) => (
            <div
              key={group}
              className={s.container}
            >
              <Skeleton
                width={140}
                height={16}
              />
              {[0, 1].map((card) => (
                <TicketSkeletonCard key={card} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </SkeletonTheme>
  )
}
